import { Component, OnInit } from '@angular/core';
import {SolicitudesService} from '../../../services/user/solicitud/solicitudes.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfirmationService, LazyLoadEvent, MessageService} from 'primeng/api';

@Component({
  selector: 'app-tramites',
  templateUrl: './tramites.component.html',
  styleUrls: ['./tramites.component.css'],
  providers: [ConfirmationService, MessageService]
})
export class TramitesComponent implements OnInit {
  /**
   * Acá se declaran las variables a utilizar en el resto de las funciones del componente, importante énfasis en las siguientes:
   *
   * code: Código del mensaje de respuesta a mostrar en la función.
   * titulo: Título a enviar; solo si se recibe con la respuesta del endpoint.
   * detalle: Detalle a enviar; solo si se recibe con la respuesta del endpoint.
   */
  solicitudes: any[];
  public id: string;
  public data: string;
  visibleSpinner = false;

  // Variables para mensaje
  code: any;
  titulo: any;
  detalle: any;
  sw: any;

  // Modal
  displayModal: boolean;
  nota: string;
  idInstancia: string;
  numero: string;
  tipo: number;
  headermodal: string;
  file1: File;
  tipoDocProrroga = 'solicitud.justificacion.prorroga';

  showMe = false;
  title: string;
  view: any;
  scroll: any;

  // Filtros de búsqueda
  searching: boolean;
  numeroSolicitud: string;
  nombreEstado: string;
  nombreProceso: string;
  codigoEstado: string[];
  codigoEstadoNOT: string[];
  estado: string;
  iconsearch: string;
  filters: any;
  totalRecords: number;

  // Tramites pendientes
  load: boolean;
  tp = false;
  tview = false;
  tmsg: boolean;
  tramites: any[];

  constructor(public solicitudesService: SolicitudesService,
              private router: Router,
              private route: ActivatedRoute,
              private confirmationService: ConfirmationService,
              private messageService: MessageService) { }

  ngOnInit(): void {
    this.scrollHeight(screen.width);
    this.route.params.subscribe((params) => {
        this.visibleSpinner = true;

        this.estado = this.route.snapshot.paramMap.get('estado');
        if (this.estado === 'pendientes') {
          this.obtenerTramitesPendientes();
        }
    });
  }

  scrollHeight(screen): any {
    let set: any
    if (screen > 1600) { set = screen * 0.65; } else { set = screen * 0.70; }
    this.scroll = screen - set;
  }

  obtenerTramitesPendientes(): void {
    this.tp = true;
    this.load = true;
    this.tmsg = false;
  }

  tramite(tramite): void {
    if (tramite !== undefined) {
      this.tramites = tramite;
      this.visibleSpinner = false;
      this.tview = true;
    }
  }

  showModal(id, numero, tipo): void {
    this.idInstancia = id;
    this.numero = numero;
    this.displayModal = true;
    this.tipo = tipo; // 1. Desistir 2.Prorroga
    if (this.tipo === 1) {
      this.headermodal = 'Desistir de solicitud';
    } else {
      this.headermodal = 'Solicitar prórroga solicitud';
    }
  }

  getURL(proceso, id): void {
    proceso = proceso.toLowerCase();
    if (id !== null) {
      this.router.navigate(['consulta/' + proceso + '/' + id]).then(() => {
        window.location.reload();
      });
    } else {
      this.router.navigate(['tramite/' + proceso]).then(() => {
        window.location.reload();
      });
    }
  }

  goToPage(pageName: string): void {
    this.router.navigate([`${pageName}`]);
  }

  historialModal(id, numero): void {
    this.title = 'Historial de estados de la solicitud ' + numero;
    this.view = { 'font-weight': 'normal', 'text-align': 'left', 'max-width': '90%' };
    this.id = id;
    this.showMe = true;
  }

  spinner(display: boolean): void {
    /**
     * Función que obtiene el valor de display emitido en el modal de historial de la solicitud.
     */
    setTimeout(() => {
      this.visibleSpinner = display;
    }, 10);
  }
}
